import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import Contact from '../contact-api-client';

export const CANCEL_SCHEDULED_MESSAGE = 'CANCEL_SCHEDULED_MESSAGE';

export const cancelScheduledText = (contactId: number, scheduledMessageId: number) =>
  createGenericDispatcher({
    name: CANCEL_SCHEDULED_MESSAGE,
    loadFunction: async () => new Contact(contactId).cancelScheduledText(scheduledMessageId),
    args: {
      contactId,
      scheduledMessageId,
    },
  });
